import { render, staticRenderFns } from "./UserDistance.vue?vue&type=template&id=56bc9e0a"
import script from "./UserDistance.vue?vue&type=script&lang=js"
export * from "./UserDistance.vue?vue&type=script&lang=js"
import style0 from "./UserDistance.vue?vue&type=style&index=0&id=56bc9e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports